import { Link, useParams } from "react-router-dom";
import { PAGES } from "@/constants/pages";

export const InfoNav = ({ slug }) => (
  <nav className="hidden flex-col gap-1 text-sm lg:sticky lg:top-36 lg:flex lg:self-start">
    {Object.entries(PAGES).map(([s, p]) => (
      <Link key={s} to={`/pagina/${s}`} className={`rounded-md px-3 py-2 ${s === slug ? "bg-[#0066FF]/10 font-semibold text-[#0066FF]" : "text-slate-500 hover:text-slate-900"}`}>{p.title}</Link>
    ))}
    <Link to="/contatti" className="rounded-md px-3 py-2 text-slate-500 hover:text-slate-900">Contatti</Link>
    <Link to="/assistenza" className="rounded-md px-3 py-2 text-slate-500 hover:text-slate-900">Assistenza</Link>
  </nav>
);

export default function InfoPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  if (!page) return <div className="py-32 text-center text-slate-500" data-testid="info-not-found">Pagina non trovata.</div>;
  return (
    <div className="mx-auto grid max-w-6xl gap-12 px-4 pt-12 sm:px-6 lg:grid-cols-[220px_1fr]" data-testid={`info-page-${slug}`}>
      <InfoNav slug={slug} />
      <article className="lt-legal min-w-0 max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#0066FF]">{page.group}</p>
        <h1 className="mt-3 font-display text-4xl font-bold tracking-[-0.03em] text-[#0A0B0E] sm:text-5xl">{page.title}</h1>
        <div className="mt-6" data-testid="info-page-content" dangerouslySetInnerHTML={{ __html: page.html }} />
      </article>
    </div>
  );
}
